export enum ApiTags {
  USERS = 'Users',
  COMPANIES = 'Companies',
  REFERENCES = 'References',
  PROJECTS = 'Projects',
  OFFERS = 'Offers',
  BIDS = 'Bids',
  AUDIT = 'Audit',
  MARKET_DEPTH = 'MarketDepth',
  MARKET_ACTIVITY = 'MarketActivity',
  ALERT_SUBSCRIPTIONS = 'AlertSubscriptions',
  NEGOTIATIONS = 'Negotiations',
  PROPOSALS = 'Proposals',
  PACKAGES = 'Packages',
  TEMPLATES = 'Templates',
  FIELD_MAPPINGS = 'FieldMappings',
  BLOCK_TRADES = 'BlockTrades',
  PENDING_METRICS = 'PendingMetrics',
  CONTRACTING_NEGOTIATIONS = 'ContractingNegotiations',
  CONTRACTING_PACKAGES = 'ContractingPackages',
  SUPPLEMENTAL_DOCUMENTS = 'SupplementalDocuments',
  TRADE_CONFIRMATION = 'TradeConfirmation',
}

// Common tag IDs
export enum CommonTagIds {
  LIST = 'LIST',
}

// Offer API tag IDs
export enum OfferTagIds {
  PROJECT_OFFERS = 'PROJECT_OFFERS',
  METRICS = 'METRICS',
}

// Project API tag IDs
export enum ProjectTagIds {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  CO_LOCATION_CANDIDATES = 'CO_LOCATION_CANDIDATES',
}

// User API tag IDs
export enum UserTagIds {
  CURRENT_USER = 'CURRENT-USER',
  MEMBERSHIPS = 'MEMBERSHIPS',
  USER_SETTINGS = 'USER-SETTINGS',
}

// Company API tag IDs
export enum CompanyTagIds {
  SEARCH = 'SEARCH',
  MEMBERSHIPS = 'MEMBERSHIPS',
  ASSIGNABLE = 'ASSIGNABLE',
  ROLES = 'ROLES',
  LEGAL_ENTITIES = 'LEGAL_ENTITIES',
  CONTRACT_LEGAL_ENTITIES = 'CONTRACT_LEGAL_ENTITIES',
}

// Reference API tag IDs
export enum ReferenceTagIds {
  USER_ROLES = 'USER_ROLES',
  ADVISOR_ROLES = 'ADVISOR_ROLES',
  REGULATORY_STATUSES = 'REGULATORY_STATUSES',
  CREDIT_PROFILES = 'CREDIT_PROFILES',
  COMPANY_ROLES = 'COMPANY_ROLES',
  COUNTRIES = 'COUNTRIES',
  STATES = 'STATES',
  COUNTIES = 'COUNTIES',
  PANEL_TYPES = 'PANEL_TYPES',
  TECHNOLOGIES = 'TECHNOLOGIES',
  PANEL_TECHNOLOGIES = 'PANEL_TECHNOLOGIES',
  TRACKING_TYPES = 'TRACKING_TYPES',
  INTERCONNECTION_POINTS = 'INTERCONNECTION_POINTS',
  INTERCONNECTION_VOLTAGES = 'INTERCONNECTION_VOLTAGES',
  COMPLIANCE_PERMIT_STATUSES = 'COMPLIANCE_PERMIT_STATUSES',
  COMPLIANCE_DOCUMENT_STATUSES = 'COMPLIANCE_DOCUMENT_STATUSES',
  BATTERY_CONFIGURATIONS = 'BATTERY_CONFIGURATIONS',
  CHARGING_SOURCES = 'CHARGING_SOURCES',
  CHARGE_RESTRICTIONS = 'CHARGE_RESTRICTIONS',
  STORAGE_TECHNOLOGIES = 'STORAGE_TECHNOLOGIES',
  CONSTRUCTION_STAGES = 'CONSTRUCTION_STAGES',
  NOTICE_TO_PROCEED_STATUSES = 'NOTICE_TO_PROCEED_STATUSES',
  LONG_LEAD_EQUIPMENT_STATUSES = 'LONG_LEAD_EQUIPMENT_STATUSES',
  OFFER_STATUSES = 'OFFER_STATUSES',
  PRODUCT_TYPES = 'PRODUCT_TYPES',
  CONTRACT_TYPES = 'CONTRACT_TYPES',
  CONTRACT_CREDIT_PROFILES = 'CONTRACT_CREDIT_PROFILES',
  NEGATIVE_PRICING = 'NEGATIVE_PRICING',
  APPLICABLE_REC_PROGRAMS = 'APPLICABLE_REC_PROGRAMS',
  PERFORMANCE_GUARANTEE_METHODS = 'PERFORMANCE_GUARANTEE_METHODS',
  APPLICABLE_TRACKING_SYSTEMS = 'APPLICABLE_TRACKING_SYSTEMS',
  REC_DELIVERY_METHODOLOGIES = 'REC_DELIVERY_METHODOLOGIES',
  ISOS = 'ISOS',
  SETTLEMENT_INDEXES = 'SETTLEMENT_INDEXES',
  HUB_ZONES = 'HUB_ZONES',
  BID_STATUSES = 'BID_STATUSES',
  PRICE_UNITS = 'PRICE_UNITS',
  CONTRACTING_FIELDS = 'CONTRACTING_FIELDS',
  DOCUMENT_PASSWORDS = 'DOCUMENT_PASSWORDS',
  APP_VERSION = 'APP_VERSION',
}

// Audit API tag IDs
export enum AuditTagIds {
  BID = 'BID',
  OFFER = 'OFFER',
  NEGOTIATION = 'NEGOTIATION',
}

// Market Depth API tag IDs
export enum MarketDepthTagIds {
  MATCHING_BIDS = 'MATCHING_BIDS',
  MATCHING_OFFERS = 'MATCHING_OFFERS',
}

// Packages API tag IDs
export enum PackageTagIds {
  LIST = 'LIST',
}

// Templates API tag IDs
export enum TemplateTagIds {
  LIST = 'LIST',
}

// Field Mappings API tag IDs
export enum FieldMappingTagIds {
  TEMPLATE = 'TEMPLATE',
}

// Contracting Packages (user-facing) API tag IDs
export enum ContractingPackageTagIds {
  LIST = 'LIST',
}

// Supplemental Documents API tag IDs
export enum SupplementalDocumentTagIds {
  LIST = 'LIST',
}

// Trade Confirmation API tag IDs
export enum TradeConfirmationTagIds {
  DETAIL = 'DETAIL',
}
